class collectionTab extends HTMLElement {
    constructor() {
        super();
        this.filterDOM = this.querySelectorAll('.filter-tab-text-wrapper.is-type-change.is-only');
        this.secondFilterDom = this.querySelectorAll('.secode-filter-tab-wrapper .secode-text')
        this.secondFilterTextDom = this.querySelectorAll('.secode-filter-tab-wrapper .secode-text span')
        this.defaultValueDom = this.querySelector('.filter-tab-text-wrapper[data-default="true"]');
        this.defaultType = this.defaultValueDom.dataset.type;
        this.defaultName = this.defaultValueDom.dataset.name;
        this.index = this.defaultValueDom.dataset.index;
        this.value = document.querySelector(`.mobile-facets-label[title="${this.defaultName}"] input`).value;
        this.FilterObject = {};
        this.urlParams = {}
    }
    connectedCallback() {
        new Promise((resolve, reject)=>{
            this.init();
            this.secondFilterDomInit()
            if(this.defaultValueDom){
                this.defaultValueDom.classList.add('is-active');
                resolve();
            }
        }).then(()=>{
            if(this.filterDOM){
                this.filterDOM.forEach((item,index) => {
                    item.onclick =(e)=>{
                        if(this.index == index) return;
                        setTimeout(()=>{
                            this.filterDOM[index].classList.add('is-active');
                            this.filterDOM[this.index].classList.remove('is-active');
                            this.defaultName = e.target.dataset.name;
                            this.defaultType = e.target.dataset.type;
                            if(this.secondFilterDom.length > 0){
                                this.secondFilterDom[index].classList.add('is-active')
                                this.secondFilterDom[this.index].classList.remove('is-active')
                            }
                            this.index = index;
                            this.urlParams[e.target.dataset.type] = e.target.dataset.param;
                            this.observeEvent()
                        },500)
                    }
                });
            }
            if(this.secondFilterDom && this.secondFilterTextDom){
                this.secondFilterTextDom.forEach((item,index) => {
                    this.urlParams[item.dataset.type] = {}
                    if(!item.dataset.param){
                        item.classList.add('hidden')
                    }
                    item.onclick =(e)=>{
                        item.classList.contains('is-active') ? item.classList.remove('is-active') : item.classList.add('is-active');
                        this.urlParams[e.target.dataset.type] && this.urlParams[e.target.dataset.type][e.target.dataset.text] ? this.urlParams[e.target.dataset.type][e.target.dataset.text] = '' : this.urlParams[e.target.dataset.type][e.target.dataset.text] = e.target.dataset.param;
                        this.observeEvent()
                    }
                })
            }
        }).then(()=>{
            setTimeout(()=>{
                this.urlParams[this.defaultType] = this.defaultValueDom.dataset.param;
                this.observeEvent(this.defaultValueDom.dataset.param);
            })
        })
    }
    secondFilterDomInit(){
        new Promise((resolve, reject)=>{
            let filterText = this.dataset.filterText.split(',');
            let temp = '';
            filterText.forEach((item,index)=>{
                temp+=filterText.length - 1 == index ? `.mobile-facets__details[data-title="${item}"] .mobile-facets-label` : `.mobile-facets__details[data-title="${item}"] .mobile-facets-label,`
            })
            resolve(temp);
        }).then((val)=>{
            let targets = document.querySelectorAll(`${val}`);
            targets.forEach((item)=>{
                let title = item.getAttribute('title');
                let paramName = item.querySelector('input').getAttribute('name');
                let paramValue = item.querySelector('input').getAttribute('value');
                let filterTabTextWrapper = this.querySelector(`.filter-tab-text-wrapper[data-name="${title}"]`);
                if(filterTabTextWrapper){
                    filterTabTextWrapper.setAttribute('data-param',`&${paramName}=${encodeURIComponent(paramValue)}`)
                }
                this.filterDOM.forEach((a,index)=>{
                    let secodeText = this.querySelector(`.secode-text span[data-text="${title}"][data-type=${a.dataset.name}]`);
                    if(secodeText){
                        secodeText.setAttribute('data-param',`&${paramName}=${encodeURIComponent(paramValue)}`)
                    }
                })
                
            })
        })
    }
    init(){
        // document.addEventListener('DOMContentLoaded', function() {
        //     const urlParams = new URLSearchParams(window.location.search);
        //     let hasFilterParams = false;
        //     for (const [key] of urlParams.entries()) {
        //         if (key.startsWith('filter.')) {
        //             hasFilterParams = true;
        //             break;
        //         }
        //     }
        //     if (hasFilterParams) {
        //         const newUrl = window.location.pathname + window.location.hash
        //         history.replaceState({}, document.title, newUrl);
        //     }
        // });
        if(document.querySelector('swiper-banner .slide-text-box .link') && !document.querySelector('swiper-banner .slide-text-box .link').getAttribute('href')){
            document.querySelector('swiper-banner .slide-text-box .link').onclick =(event)=>{
                event.preventDefault();
                window.scrollTo({
                    top: this.getBoundingClientRect().top,
                    behavior: 'smooth'
                });
            }
        }
    }
    getCollectionPageNumber() {
        const currentUrl = window.location.href;
        const url = new URL(currentUrl);
        const pageNumber = url.searchParams.get('page');
        if (pageNumber && !isNaN(pageNumber)) {
            return parseInt(pageNumber);
        }
    }
    getCollectionSortBy() {
        const currentUrl = window.location.href;
        const url = new URL(currentUrl);
        const sortBy = url.searchParams.get('sort_by');
        if(sortBy){
            return sortBy;
        }
    }
    observeEvent(url){
        let param = '';
        let sortDom = document.querySelector('.sort-by-wrapper .mobile-facets__label--checked input')
        new Promise((resolve, reject)=>{
            if(this.urlParams && !url){
                for(let i in this.urlParams){
                    if(this.urlParams[i] && i == this.defaultType){
                        param += this.urlParams[i];
                    }
                    else if(this.urlParams[i] && i == this.defaultName){
                        for(let key in this.urlParams[i]){
                            param += this.urlParams[i][key] || ''
                        }
                    }
                }
                resolve(param)
            }
            else{
                resolve(url)
            }
        }).then((val)=>{
            setTimeout(()=>{
                let pageNum = this.getCollectionPageNumber();
                let sortValue = url ? this.getCollectionSortBy() : sortDom && sortDom.value;
                let paramUrl = pageNum && url ? `${window.location.pathname}?sort_by=${sortValue}${val}&page=${this.getCollectionPageNumber()}` : `${window.location.pathname}?sort_by=${sortValue}${val}`;
                fetch(paramUrl)
                .then((response) => { 
                    if (!response.ok) {
                        let error = new Error(response.status);
                        // this.close();
                        throw error;
                    }
                    return response.text();
                })
                .then((text)=>{
                    const grid = new DOMParser().parseFromString(text, 'text/html');
                    document.querySelector('.product-grid-container').innerHTML = grid.querySelector('.product-grid-container').innerHTML;
                    let filterText = this.dataset.filterText.split(',');
                    let temp = '';
                    filterText.forEach((item,index)=>{
                        document.querySelector(`.mobile-facets__details[data-title="${item}"]`).classList.add('hidden')
                    })
                })
            })
        })
        
        
    }
}
customElements.define('collection-tab', collectionTab);